import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={25}
    height={26}
    viewBox="0 0 25 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#7879B2'}
      d="M10.88.973C5.2.973.59 5.583.59 11.273c0 5.68 4.61 10.29 10.3 10.29 2.17 0 4.29-.69 6.04-1.97l5.13 5.13a1.611 1.611 0 1 0 2.28-2.28l-5.13-5.13c3.34-4.59 2.33-11.02-2.27-14.37a10.329 10.329 0 0 0-6.07-1.97h.01Zm0 17.36c-3.9 0-7.06-3.16-7.06-7.06 0-3.9 3.16-7.06 7.06-7.06 3.9 0 7.06 3.16 7.06 7.06 0 3.9-3.16 7.06-7.06 7.06Z"
    />
  </Svg>
);
export default SvgComponent;
